<div class="p-4 my-4 border-l-4 border-gray-300">
  <p class="text-base italic leading-relaxed">
    {{ 'organizer.verify_identity_description' | translate }}
  </p>
</div>

<div class="text-base my-4"></div>

<app-bank-id-button
(bankIdClick)="startValidation()">
{{ 'organizer.verify_with_bankid' | translate }}
</app-bank-id-button>





